import * as v2 from '@/core/services/api/v2';
import { logHttpError } from '@/core/utils/http-error-logger';

export default {
  namespaced: true,

  state: {
    playerRewards: [],
    showRewardView: false,
    currentRewards: []
  },

  mutations: {
    SET_PLAYER_REWARDS(state, rewards) {
      state.playerRewards = rewards;
    },
    SET_SHOW_REWARD_VIEW(state, show) {
      state.showRewardView = show;
    },
    SET_CURRENT_REWARDS(state, rewards) {
      state.currentRewards = rewards;
    }
  },

  actions: {
    /**
     * As conquistas recém-alcançadas e ainda não resgatadas — o "acabou de
     * conquistar" que o `RewardView.vue` celebra. A lista devolvida é de
     * **nomes em PT**: é esse o contrato do RewardView, que compara por nome.
     *
     * Antes de devolver, cada uma é resgatada de fato no servidor
     * (`achievements/:id/claim` credita o bônus de energia) — no Strapi o
     * "last-rewards" já marcava como visto; aqui o resgate é explícito.
     */
    async getLastRewards(_, playerId) {
      try {
        const conquistas = await v2.conquistas(playerId);
        const recentes = conquistas.filter(c => c.alcancada && !c.resgatada);

        for (const conquista of recentes) {
          try {
            await v2.resgatarConquista(playerId, conquista.id);
          } catch (error) {
            // 409 = já resgatada (outra aba, clique duplo): não é falha, a
            // conquista segue na lista para ser exibida. Outros erros também
            // não derrubam o lote — cada resgate é independente.
            if (error.response?.status !== 409) {
              logHttpError(error, {
                method: 'POST',
                url: `/api/player/${playerId}/achievements/${conquista.id}/claim`,
                data: {}
              });
            }
          }
        }

        return { lastRewards: recentes.map(c => c.nome) };
      } catch (error) {
        logHttpError(error, {
          method: 'GET',
          url: `/api/player/${playerId}/achievements`,
          data: {}
        });
        throw error;
      }
    },
    async checkAndShowRewards({ commit }, playerId) {
      try {
        const response = await this.dispatch('rewards/getLastRewards', playerId);
        if (response && response.lastRewards && response.lastRewards.length > 0) {
          commit('SET_CURRENT_REWARDS', response.lastRewards);
          commit('SET_SHOW_REWARD_VIEW', true);
          return response.lastRewards;
        }
        return [];
      } catch (error) {
        console.error('Error checking rewards:', error);
        return [];
      }
    },

    hideRewardView({ commit }) {
      commit('SET_SHOW_REWARD_VIEW', false);
      commit('SET_CURRENT_REWARDS', []);
    }
  }
};
